import React from 'react';
import ProviderRow from './ProviderRow';
import { BiSortZA, BiSortAZ } from 'react-icons/bi';
import intl from 'components/i18n/ReactIntlWrapper';

const ProviderList = ({ searchResult, input, setInput }) => {

    const handleSortClick = (sort) => {
        setInput({ ...input, orderValue: (input.sortValue == sort ? (input.orderValue == 'desc' ? 'asc' : 'desc') : 'asc'), sortValue: sort, currentPage: 1 });
    }

    return (
        <div className="table-responsive my-2">
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <th role='button' onClick={() => { handleSortClick('Name') }} scope="col">{intl.get('providerList.table.thead.name')} {input.sortValue == 'Name' ? (input.orderValue == 'desc' ? <BiSortZA></BiSortZA> : <BiSortAZ></BiSortAZ>) : ''}</th>
                        <th scope="col" className='text-center'>{intl.get('roleList.table.thead.actions')}</th>
                    </tr>
                </thead>
                {
                    searchResult?.providers?.length < 1 && input.queryTerm !== null ?
                    <tbody className='aling-center mb-0'>
                        <tr>
                            <td colSpan={6} className='mb-0' style={{cursor: "default"}}>{intl.get('providerList.notFound')}</td>
                        </tr>
                    </tbody> :
                    <tbody>
                        {
                            searchResult?.providers?.length >= 1  && searchResult.providers.map((c,i) => (
                                <ProviderRow
                                key={c.id}
                                id={c.id}
                                name={c.name}
                                className={i%2>0?'':'odd'}
                                />
                            ))
                        }
                    </tbody>
                }
            </table>
        </div>
    )
}

export default ProviderList;
